import { callAPI, HTTPMethod, getAuthenticatedGetUrl } from "./API";
import { Payments, Payment, SchedulePaymentRequest, PaymentExchangeRateResponse, PaymentMetadataResponse, PaymentsQueryParams, RegisterTransactionRequest, RegisterPaymentRequest } from "../model/Payment";

const basePath = (tenantId: string, customerId: string) => {
    return `/tenants/${tenantId}/customers/${customerId}/payments`;
};

export async function listPayments(tenantId: string, customerId: string, page: number, offset: number, params: PaymentsQueryParams): Promise<Payments> {
    const query = {
        search: params.search,
        archive: params.archive,
        pageSize: page.toString(),
        offset: offset.toString(),
    } as any;

    if (params.status) {
        query["status"] = params.status;
    }

    return await callAPI(`${basePath(tenantId, customerId)}`, {
        method: HTTPMethod.GET,
        query: query
    });
}

export async function createPayment(tenantId: string, customerId: string, request: SchedulePaymentRequest): Promise<Payment> {
    return await callAPI(basePath(tenantId, customerId), {
        method: HTTPMethod.POST,
        body: request
    });
}

export async function registerPayment(tenantId: string, customerId: string, request: RegisterPaymentRequest): Promise<Payment> {
    return await callAPI(`${basePath(tenantId, customerId)}/register`, {
        method: HTTPMethod.POST,
        body: request
    });
}

export async function metadata(tenantId: string, customerId: string): Promise<PaymentMetadataResponse> {
    return await callAPI(`${basePath(tenantId, customerId)}/metadata`, {
        method: HTTPMethod.GET
    });
}

export async function getPaymentExchangeRate(tenantId: string, customerId: string, currency: string): Promise<PaymentExchangeRateResponse> {
    return await callAPI(`${basePath(tenantId, customerId)}/exchange-rate`, {
        method: HTTPMethod.GET,
        query: {
            currency: currency
        }
    });
}

export async function getPayment(tenantId: string, customerId: string, paymentId: string): Promise<Payment> {
    return await callAPI(`${basePath(tenantId, customerId)}/${paymentId}`, {
        method: HTTPMethod.GET,
    });
}

export async function updatePayment(tenantId: string, customerId: string, paymentId: string, request: SchedulePaymentRequest): Promise<Payment> {
    return await callAPI(`${basePath(tenantId, customerId)}/${paymentId}`, {
        method: HTTPMethod.PUT,
        body: request
    });
}

export async function registerTransaction(tenantId: string, customerId: string, paymentId: string, request: RegisterTransactionRequest): Promise<Payment> {
    return await callAPI(`${basePath(tenantId, customerId)}/${paymentId}`, {
        method: HTTPMethod.PATCH,
        body: request
    });
}

export async function deletePayment(tenantId: string, customerId: string, paymentId: string): Promise<any> {
    return await callAPI(`${basePath(tenantId, customerId)}/${paymentId}`, {
        method: HTTPMethod.DELETE
    });
}

export async function getPaymentUrl(tenantId: string, customerId: string, paymentId: string): Promise<string> {
    return getAuthenticatedGetUrl(`${basePath(tenantId, customerId)}/${paymentId}/file`);
}
